import { render } from "./manageProcess.vue?vue&type=template&id=66f3ef45&scoped=true&ts=true"
import script from "./manageProcess.vue?vue&type=script&lang=ts"
export * from "./manageProcess.vue?vue&type=script&lang=ts"

import "./manageProcess.vue?vue&type=style&index=0&id=66f3ef45&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66f3ef45"]])

export default __exports__